// Keep the complete core stylesheet here. Mantine components compose internal
// components, so selective CSS imports are easy to make incomplete or mis-order.
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "./typographyCompatibility.css";
import "./notificationCompatibility.css";

import React from "react";
import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { mantineTheme } from "./mantineTheme";
import {
    APPLICATION_MODAL_Z_INDEX,
    NOTIFICATION_Z_INDEX,
} from "../components/ui/overlayLayers";

type MantineRootProps = React.PropsWithChildren;

export const MantineRoot: React.FC<MantineRootProps> = ({ children }) => (
    <MantineProvider theme={mantineTheme} forceColorScheme="light">
        <DatesProvider settings={{ locale: "en", firstDayOfWeek: 0 }}>
            <ModalsProvider modalProps={{ zIndex: APPLICATION_MODAL_Z_INDEX }}>
                {children}
                <Notifications
                    position="top-right"
                    autoClose={6000}
                    containerWidth={360}
                    zIndex={NOTIFICATION_Z_INDEX}
                />
            </ModalsProvider>
        </DatesProvider>
    </MantineProvider>
);
